module.exports = __webpack_public_path__ + "img/Postmodernisme_Anne-B.-Ragde.3581a64c.jpg";